export default __webpack_public_path__ + "static/media/portfolio-190.0146246a.jpg";